import { render, staticRenderFns } from "./createEspecialidade.vue?vue&type=template&id=4ed3dd09&scoped=true&"
import script from "./createEspecialidade.vue?vue&type=script&lang=js&"
export * from "./createEspecialidade.vue?vue&type=script&lang=js&"
import style0 from "./createEspecialidade.vue?vue&type=style&index=0&id=4ed3dd09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed3dd09",
  null
  
)

export default component.exports